import React from "react";
import NewProfileButton from "../components/NewProfileButton";
import LineGraph from "../components/LineGraph";
import ScoreBreakDown from "../components/ScoreBreakDown";
import SmartContractContainer from "../components/SmartContractContainer";
// import SortSmartContracts from "../Utils/SortSmartContracts";
import ConvertTimeStamp from "../Utils/ConvertTimeStamp";
const Overview = (props) => {
  let latestKey = props.activeProfile.Latest;
  const Subscribed = props.Subscribed;
  let paidHistory = props.activeProfile.paidHistory;
  if (
    props.activeProfile.History === undefined ||
    Object.keys(props.activeProfile.History).length === 0
  ) {
    // console.log("Empty History");
    return (
      <div>
        <p>You currently have no score history to display.</p>
        <NewProfileButton
          userKey={props.profileData.QFUserID}
          email={props.profileData.email}
          profileData={props.profileData}
          activeProfile={props.activeProfile}
        />
        {props.Dev ? <p>{JSON.stringify(props.activeProfile)}</p> : <></>}
      </div>
    );
  } else {
    if (props.activeProfile.History[latestKey] === undefined) {
      latestKey = Object.keys(props.activeProfile.History)[0];
    }
    return (
      <div id="Top">
        <h2>Take a look at your most recent score</h2>(
        {ConvertTimeStamp(latestKey)})
        {props.Dev ? (
          <div>
            <p>
              Hello {props.activeProfile.Name.trim()},<br /> you are{" "}
              {Subscribed === true
                ? "currently subscribed"
                : "not a subscriber"}
            </p>
          </div>
        ) : (
          <></>
        )}
        <div id="Score History">
          {Subscribed && paidHistory !== undefined ? (
            Object.keys(paidHistory).length > 1 ? (
              <>
                <LineGraph History={paidHistory}></LineGraph>
                <p>
                  {`You currently have ${
                    Object.keys(paidHistory).length
                  } Scores`}
                </p>
              </>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </div>
        <br />
        <br />
        <div>
          <ScoreBreakDown
            logo={props.logo}
            Quotes={props.Quotes}
            activeProfile={props.activeProfile}
            Subscribed={Subscribed}
            label="Latest Score"
            currentKey={latestKey}
            currentProfileIdx={props.activeProfileIdx}
            UserID={props.userKey}
            Dev={props.Dev}
          ></ScoreBreakDown>
          <br />
        </div>
        {/* <div>
          {props.Dev === true &&
          props.activeProfile.History[latestKey].Reports !== "Unpaid" ? (
            <SmartContractContainer
              SmartContracts={
                props.activeProfile.History[latestKey].Reports.SmartContracts
              }
            />
          ) : (
            <></>
          )}
        </div> */}
        {/* <NewProfileButton
          userKey={props.profileData.QFUserID}
          email={props.profileData.email}
          profileData={props.profileData}
          activeProfile={props.activeProfile}
        /> */}
        {props.Dev ? <p>{JSON.stringify(props.activeProfile)}</p> : <></>}
      </div>
    );
  }
};

export default Overview;
